import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import RemoveMakeModal from 'src/components/global-settings/RemoveMakeModal'
import { removeVehicleMake, getVehicleCreateOptions } from 'src/state/actions/vehicles'
import { getVehicleMake } from 'src/state/selectors'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    id: ownProps.match.params.id,
    setting: getVehicleMake(ownProps.match.params.id, state)
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    removeVehicleMake: (id: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeVehicleMake(id)).then(() => {
          dispatch(getVehicleCreateOptions()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RemoveMakeModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/RemoveMakeModal.ts